/**
 * Badge PERMANENTE su una richiesta la cui conferma è stata revocata (V68).
 *
 * Non è cosmetico ed è deliberatamente NON chiudibile: dopo la rigenerazione
 * `_delete_generato` cancella le righe `origine='generato'` deprecate, quindi
 * dei documenti superati resta visibile solo il preventivo FIRMATO. Questo
 * badge diventa l'unica traccia stabile che la riapertura sia avvenuta.
 *
 * Alimentato da `revoca` (proiezione delle colonne V68 `riaperta_at/da`),
 * presente su ogni GET del dettaglio.
 */
import { RotateCcw } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import type { RevocaInline } from '../api/richieste';

function formatDateIT(iso: string): string {
  return new Date(iso).toLocaleDateString('it-IT', { day: '2-digit', month: 'long', year: 'numeric' });
}

export default function BadgeRevocaConferma({ revoca }: { revoca: RevocaInline }) {
  const { t } = useTranslation();
  return (
    <div
      data-testid="badge-revoca-conferma"
      className="flex items-start gap-2.5 px-4 py-3 rounded-lg border border-accent-warning/30 bg-accent-warning-bg text-sm text-ink-dark"
    >
      <RotateCcw size={16} className="text-accent-warning flex-shrink-0 mt-0.5" />
      <div className="space-y-0.5">
        <p>
          {t('richieste.workflow.badge_revoca', { data: formatDateIT(revoca.riaperta_at) })}
          {revoca.riaperta_da_nome
            ? ` — ${t('richieste.workflow.badge_revoca_da', { utente: revoca.riaperta_da_nome })}`
            : ''}
        </p>
        <p className="text-xs text-ink-soft">{t('richieste.workflow.badge_revoca_nota')}</p>
      </div>
    </div>
  );
}
